import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { StaticRouter } from 'react-router';
import { Provider } from 'react-redux';
import sanitizeHtml from 'sanitize-html';
import StyleContext from 'isomorphic-style-loader/StyleContext';
import shortcodeMap, { onParseMap } from 'config/shortcodes';
import { plainText } from 'config/sanitizeHTML';
import { insertCss } from 'utils/css';

import createParser from './shortcodeParser';

const parser = createParser();

Object.keys(shortcodeMap).forEach((shortcode) => {
  parser.add(shortcode, (attributes) => {
    let props = attributes;
    if (onParseMap[shortcode]) {
      props = onParseMap[shortcode](attributes);
    }

    const Component = shortcodeMap[shortcode];
    if (props.store) {
      return renderToStaticMarkup(
        <Provider store={props.store}>
          <StaticRouter context={{}}>
            <StyleContext.Provider value={{ insertCss }}>
              <Component {...props} />
            </StyleContext.Provider>
          </StaticRouter>
        </Provider>,
      );
    }

    return renderToStaticMarkup(
      <StaticRouter context={{}}>
        <StyleContext.Provider value={{ insertCss }}>
          <Component {...props} />
        </StyleContext.Provider>
      </StaticRouter>,
    );
  });
});

export default (content) => {
  const html = content ? sanitizeHtml(content, plainText) : content;
  return { __html: html };
};

export const setRichTextInnerHTML = (content, contextProps) => {
  // Parser will sanitize HTML for rich text
  const html = content ?
    parser.parse(content, contextProps) :
    content;
  return { __html: html };
};
